// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"2bd99c94","164":"2c7a8cb8","986":"6c3cf22f"}[chunkId] + ".css";
};